import { Icon } from '@/src/components/ui';
import React from 'react';

export const YouTubeBlock = ({
  children,
  youtubeThumb,
  title,
  description,
}: {
  children?: React.ReactNode;
  youtubeThumb: string;
  title: string;
  description: string;
}) => {
  return (
    <div className="group flex gap-3 bg-bg-gray rounded-2xl p-3 items-start relative w-full">
      <div className="shrink-0">
        <img
          src={youtubeThumb || '/images/youtube-placeholder.png'}
          alt={title || 'YouTube thumbnail'}
          className="w-36 h-24 rounded-xl object-cover"
        />
      </div>

      <div className="flex-1 min-w-0 flex flex-col gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <Icon name="youtube" className="size-6 shrink-0" />

          <span className="font-semibold text-sm min-w-0 truncate">
            {title || 'Video heading'}
          </span>
        </div>

        <div className="text-xs text-gray-600 line-clamp-3 break-words">
          {description || 'No description available for this video.'}
        </div>
      </div>

      {children}
    </div>
  );
};

